import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
function getRoleForItem(item) {
    switch (item.type) {
        case 'radio':
            return 'menuitemradio';
        case 'checkbox':
            return 'menuitemcheckbox';
        default:
            return 'menuitem';
    }
}
function isChecked(item) {
    return (item.type === 'radio' || item.type === 'checkbox') && item.checked;
}
export const MenuItemComponent = React.memo(function MenuItemComponent({ item, focused, tabIndex, onClick, hasOpenSubmenu, }) {
    const role = getRoleForItem(item);
    const checked = isChecked(item);
    const disabled = item.disabled === true;
    const classNames = [
        'hekate-menu-item',
        checked ? 'hekate-menu-item--active' : '',
        disabled ? 'hekate-menu-item--disabled' : '',
    ]
        .filter(Boolean)
        .join(' ');
    const handleClick = () => {
        if (!disabled) {
            onClick();
        }
    };
    const ariaProps = {};
    if (item.type === 'radio' || item.type === 'checkbox') {
        ariaProps['aria-checked'] = item.checked;
    }
    if (disabled) {
        ariaProps['aria-disabled'] = 'true';
    }
    if (item.type === 'submenu') {
        ariaProps['aria-haspopup'] = 'menu';
        ariaProps['aria-expanded'] = hasOpenSubmenu ?? false;
    }
    // Render icon if present
    const icon = 'icon' in item && item.icon ? (_jsx("span", { className: "hekate-menu-item-icon", children: item.icon })) : null;
    // Render hint if present
    const hint = 'hint' in item && item.hint ? (_jsx("span", { className: "hekate-menu-item-hint", children: item.hint })) : null;
    // Render submenu arrow
    const arrow = item.type === 'submenu' ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spacer" }), _jsx("span", { className: "hekate-menu-item-arrow" })] })) : null;
    // Render label
    const label = item.type === 'custom' ? item.render({ focused }) : (_jsxs(_Fragment, { children: [icon, _jsx("span", { className: "hekate-menu-item-label", children: 'label' in item ? item.label : null }), hint, arrow] }));
    return (_jsx("div", { role: role, className: classNames, tabIndex: tabIndex, "data-menu-item": "", "data-menu-item-id": item.id, onClick: handleClick, ...ariaProps, children: label }));
});
